import { OuterWrapper } from "client/packages/commerce/components/ui/styles/Containers"

import { useVariantFromCache } from "../hooks"
import { useActiveSaleHighlights } from "../hooks/useActiveSale"

import TargetAddedToCartConfirmation from "./cart/TargetAddedToCartConfirmation"
import { useTargetContext } from "./TargetContext"
import MultiProductSelection from "./TargetMultiProductSelection"
import ProductHeader from "./TargetProductHeader"
import { ProductSelection } from "./TargetProductSelection"

type TargetProductFlowProps = {
  showCart: () => void
  currencyCode: string
  channelId: string
  resetProductPage: () => void
}

const TargetProductFlow = ({
  showCart,
  currencyCode,
  channelId,
  resetProductPage,
}: TargetProductFlowProps) => {
  // FIXME: activeSale can be null. This will be explicit when #1479 is fixed
  const [activeSale] = useActiveSaleHighlights(channelId)
  const {
    currentlySelectedProductId,
    setCurrentlySelectedProductId,
    addedProduct,
    setAddedProduct,
  } = useTargetContext()

  const [addedVariant] = useVariantFromCache(
    addedProduct?.productId,
    addedProduct?.variantId,
  )

  const handleShowCart = () => {
    setAddedProduct(null)
    showCart()
  }

  // This is conditionally set to null if there is only one product
  // so that a back button is not rendered.
  const onBack =
    !activeSale || activeSale.visibleProductIds.length < 2
      ? null
      : resetProductPage

  return (
    <OuterWrapper>
      {addedProduct && (
        <TargetAddedToCartConfirmation
          cartItem={addedProduct}
          productVariant={addedVariant}
          continueShopping={resetProductPage}
          handleShowCart={handleShowCart}
          dismissModal={() => setAddedProduct(null)}
        />
      )}
      <ProductHeader showCart={showCart} />
      {currentlySelectedProductId ? (
        <ProductSelection
          currencyCode={currencyCode}
          productId={currentlySelectedProductId}
          onBack={onBack}
          showConfirmation={setAddedProduct}
        />
      ) : (
        <MultiProductSelection
          featuredProductId={activeSale?.featuredProductId}
          visibleProductIds={activeSale?.visibleProductIds ?? []}
          products={activeSale?.products ?? []}
          setCurrentProductId={setCurrentlySelectedProductId}
          currencyCode={currencyCode}
        />
      )}
    </OuterWrapper>
  )
}

export default TargetProductFlow
